// baseurl.js

// Backend API base URL
export const baseurl = "https://subcity.evventoz.com/api/"; 
// export const baseurl = "http://192.168.1.6/api/"; 

// Image base URL (for static uploads)
export const imgurl = "https://subcity.evventoz.com/"; 
